var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-menu"},[_c('a',{staticClass:"profile-button",class:{'active': _vm.notificationsVisible, 'notification-dot': _vm.notificationsCount > 0 },attrs:{"href":"#"},domProps:{"innerHTML":_vm._s(_vm.notificationIcon)},on:{"click":function($event){$event.preventDefault();return _vm.toggleNotifications.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }